// src/components/ThemeToggle.js

import React, { useState, useEffect } from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';

const getInitialTheme = () => localStorage.getItem('theme') || 'dark';

function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    const isDark = theme === 'dark';
    // Tailwind dark: prefix
    document.documentElement.classList.toggle('dark', isDark);
    // CSS variables legadas (body.light-theme)
    document.body.classList.toggle('light-theme', !isDark);
  }, [theme]);

  return (
    <button
      onClick={toggleTheme}
      title="Alterar Tema"
      className="flex w-full items-center gap-2.5 rounded-lg px-4 py-3 text-sm font-medium transition-colors duration-200 hover:bg-white/10"
      style={{ color: 'var(--text-primary)' }}
    >
      {theme === 'light' ? (
        <FiMoon className="text-base shrink-0" />
      ) : (
        <FiSun className="text-base shrink-0" />
      )}
      <span>{theme === 'light' ? 'Tema Escuro' : 'Tema Claro'}</span>
    </button>
  );
}

export default ThemeToggle;